/* eslint-disable */
import React, { Suspense, useEffect } from "react";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import { MenuConfig } from "../components/parts";
import NotFound from "../components/page/notFound";
import Loadable from "react-loadable";
import { pathChannel, pathConfig, pathFilter } from "./path";
import styled from "styled-components";
import Skeleton from "@material-ui/lab/Skeleton";
import { USER_LOGIN, USER_LOGOUT } from "../store/actions";
import Loader from "../components/parts/loader/loader";
//import { init, terminate } from "api/integration-wde.js";
import { history } from "../store";
import { env } from "env";
import { profile } from "./profile";
import CustomDash from "components/page/main/customDash";

function Loading({ error }) {
  if (error) {
    console.log(error);
    return error;
  } else {
    return <Loader />;
  }
}

let isLogin = env.REACT_APP_ISLOGIN === "true";

const Menu = Loadable({

  loader: () => {

    if (env.REACT_APP_NEW_MENU === 'true') {
      return import("../components/parts/menuv2");
    } else {
      return import("../components/parts/menu");
    }
  },
  loading: () => <Skeleton width="100%" height="64px" />,
});

const Main = Loadable({
  loader: () => import("../components/page/main"),
  loading: Loading,
});

const Login = Loadable({
  loader: () =>
    import(`../components/page/login/${isLogin ? "login" : "email"}`),
  loading: Loading,
});

const Automation = Loadable({
  loader: () => import("../components/page/automation"),
  loading: Loading,
});

const Campaign = Loadable({
    loader: () => import("../components/page/campaign"),
    loading: Loading,
});
//const NotFound = Loadable({loader: () => import('../components/page/notFound'), loading: Loading});

const Archive = Loadable({
  loader: () => import("../components/page/archive"),
  loading: Loading,
});

const Flow = Loadable({
  loader: () => import("../components/page/smartflow"),
  loading: Loading,
});

const Cockpit = Loadable({
  loader: () => import("../components/page/cockpit"),
  loading: Loading,
});

const Crm = Loadable({
  loader: () => import("../components/page/crm"),
  loading: Loading,
});

const Customers = Loadable({
  loader: () => {
    if (
        env.REACT_APP_NEW_CRM === 'true'
    ) {
      return import("../components/page/crmv3");
    } else {
      return import("../components/page/customersv2");
    }
  },
  loading: Loading,
});

const Workflow = Loadable({
  loader: () => {
    if (
        env.REACT_APP_NEW_WORKFLOW === 'true'
    ) {
      return import("../components/page/workflowv2/");
    } else {
      return import("../components/page/workflow/");
    }
  },
  loading: Loading,
});

const ChatV2 = Loadable({
  loader: () => import("../components/page/cockpitv2/"),
  loading: Loading,
});

const Settings = Loadable({
  loader: () => import("../components/page/settings"),
  loading: Loading,
});

const Crmv3 = Loadable({
  loader: () => import("../components/page/crmv3"),
  loading: Loading,
});

const Schema = Loadable({
  loader: () => import("../components/page/settings/database/schema"),
  loading: Loading,
});

const pathChats = [];

pathChannel.map((filter) => pathChats.push(`${filter}`));
pathFilter.map((filter) => pathChats.push(`${filter}`));
pathChannel.map((channel) =>
pathFilter.map((filter) => pathChats.push(`${channel}/${filter}`))
);

const Container = styled.div`
  display: flex;
  flex-basis: 100%;
  max-height: calc(100% - 64px);

  &.isChat {
    width: 100%;
  }
`;

const PrivateRoute = ({ auth, role, component: Component, ...rest }) => {
  const isPathConfig = (pathname) => {
    let path = pathname.split("/").filter((x) => x.length > 0);
    return (
      path[0] === "configuracoes" &&
      (!path[2] || path[2] !== "novo") &&
      (path.length === 1 || (path.length >= 2 && pathConfig.includes(path[1])))
    );
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        auth.isLogged ? (
          <Suspense fallback={<div>Loading...</div>}>
            {typeof role === "boolean" && !role ? (
              <NotFound />
            ) : (
              <>
                {/*<Menu />*/}
                <Container>
                  {isPathConfig(history.location.pathname) && <MenuConfig />}
                  <Component {...props} />
                </Container>
              </>
            )}
          </Suspense>
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
};

// CockpitRoute - need to do this because the Private route is re rendering multiple times the component
// the problem is the HoC of the function... calls multiple times... breaking react subroutes
// TODO: need to change the component function of PrivateRoute
const CockpitRoute = ({ auth, role }) => {
  if (!auth.isLogged)
    return (
      <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
    );

  return (
    <Route
      path={"/chats"}
      render={(props) => (
        <Suspense fallback={<div>Loading...</div>}>
          {typeof role === "boolean" && !role ? (
            <NotFound />
          ) : (
            <>
              {/*<Menu />*/}
              <Container>
                <Cockpit department={auth.department} auth={auth} {...props} />
              </Container>
            </>
          )}
        </Suspense>
      )}
    />
  );
};

const Routes = (props) => {
  const { auth } = props;
  const { pathname } = history.location;
  /*useEffect(() => {
    if (auth && auth.isLogged && auth.type === USER_LOGIN) {
      //init(localStorage.getItem("token"), auth.login);
    } else {
      if (auth && auth.type === USER_LOGOUT) {
        //terminate();
        //localStorage.setItem("wde_auth", null);
      }
    }
  }, [auth]);*/

  return !auth ? (
    ""
  ) : (
    <Router history={history}>
      {auth.isLogged && <Menu />}
      <Switch>
        <Route exact path="/login" component={Login} />
        <PrivateRoute
          auth={auth}
          exact
          path="/"
          component={() =>
            (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />
        <PrivateRoute
          auth={auth}
          exact
          path="/analitico-atendimento"
          component={() =>
            profile[auth.role]?.dashboard ? (
              <Main view={"analitico-atendimento"} />
            ) : (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />
        <PrivateRoute
          auth={auth}
          exact
          path="/analitico-campanha"
          component={() =>
            profile[auth.role]?.dashboard ? (
              <Main view="analitico-campanha" />
            ) : (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />
        <PrivateRoute
          auth={auth}
          exact
          path="/analitico-monitoria"
          component={() =>
            profile[auth.role]?.dashboard ? (
              <Main view="analitico-monitoria" />
            ) : (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />
        <PrivateRoute
          auth={auth}
          exact
          path="/analitico-ocorrencia"
          component={() =>
            profile[auth.role]?.dashboard ? (
              <Main view="analitico-ocorrencia" />
            ) : (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />
        <PrivateRoute
          auth={auth}
          exact
          path="/analitico-pesquisa"
          component={() =>
            profile[auth.role]?.dashboard ? (
              <Main view="analitico-pesquisa" />
            ) : (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />
        <PrivateRoute
          auth={auth}
          exact
          path="/analitico-ticket"
          component={() =>
            profile[auth.role]?.dashboard ? (
              <Main view="analitico-ticket" />
            ) : (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />
        <PrivateRoute
          auth={auth}
          exact
          path="/analitico-transferencia"
          component={() =>
            profile[auth.role]?.dashboard ? (
              <Main view="analitico-transferencia" />
            ) : (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />
        <PrivateRoute
          auth={auth}
          exact
          path="/analitico-watson"
          component={() =>
            profile[auth.role]?.dashboard ? (
              <Main view="analitico-watson" />
            ) : (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />

        <PrivateRoute
          auth={auth}
          exact
          path="/monitoria-auditoria"
          component={() =>
            profile[auth.role]?.dashboard ? (
              <Main view="monitoria-auditoria" />
            ) : (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />

        <PrivateRoute
          auth={auth}
          exact
          path="/dashboard-atendimento"
          component={() =>
            profile[auth.role]?.dashboard ? (
              <Main view="dashboard-atendimento" />
            ) : (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />

        <PrivateRoute
          auth={auth}
          exact
          path="/analitico-logs"
          component={() =>
            profile[auth.role]?.dashboard ? (
              <Main view="analitico-logs" />
            ) : (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />

         <PrivateRoute
          auth={auth}
          exact
          path="/relatorios-personalizados"
          component={() =>
            profile[auth.role]?.dashboard ? (
              <CustomDash view="relatorios-personalizados" />
            ) : (
              <Redirect to="/chats/humano/atendimento" />
            )
          }
        />
        <PrivateRoute
          auth={auth}
          role={profile[auth.role]?.Schema}
          path="/schema"
          component={() => <Schema />}
        />
        <PrivateRoute
          auth={auth}
          role={profile[auth.role]?.Schema}
          path="/crmv3"
          component={() => <Crmv3 />}
        />
        <PrivateRoute
            auth={auth}
            exact
            path="/automation"
            component={() => <Automation />}
        />
        <PrivateRoute
            auth={auth}
            exact
            path="/campaign"
            component={() => <Campaign />}
        />
        <PrivateRoute
          auth={auth}
          role={profile[auth.role]?.customer}
          path="/customers"
          component={() => <Customers />}
        />
        <PrivateRoute
          auth={auth}
          role={profile[auth.role]?.crm}
          path="/crm"
          component={() => <Crm />}
        />

        <PrivateRoute
          role={profile[auth.role]?.workflow}
          auth={auth}
          path="/workflow"
          component={() => <Workflow />}
        />

        <PrivateRoute
          auth={auth}
          exact
          role={profile[auth.role]?.flow}
          path="/flow"
          component={() => <Flow />}
        />

        <PrivateRoute
          auth={auth}
          exact
          role={profile[auth.role]?.crm}
          path="/arquivo"
          component={() => <Archive />}
        />

        <PrivateRoute
          auth={auth}
          role={profile[auth.role]?.config}
          path="/configuracoes"
          component={() => <Settings />}
        />

        {env.REACT_APP_NEW_CHAT === 'true' ? (
          <PrivateRoute
            role={profile[auth.role]?.chat}
            auth={auth}
            path="/chats"
            component={() => <ChatV2 />}
          />
        ) : (
          <CockpitRoute role={profile[auth.role]?.chat} auth={auth} />
        )}

        <Route path="*" component={NotFound} />
      </Switch>
    </Router>
  );
};

export default Routes;
